module.exports = __webpack_public_path__ + "static/media/gallery.5f3dcd58.svg";